$(function() {
  require('owl.carousel')

  $('.header__button button').on('click', function (e) {
      e.preventDefault()

      $('.mobile-menu').slideToggle()
      $(this).toggleClass('up')
      $('body').toggleClass('overflow-hidden')
  })

  $('.mobile-menu > ul > li >a').on('click', function (e) {
      e.preventDefault()

      $(this).parent().find('ul').slideToggle()
      $(this).toggleClass('rotated')
  })

  let menuTo = null

  $('.header__menu__items__item__link').on('mouseenter', function () {
      $('.menu-dropdown').removeClass('menu-dropdown--active')
      if (menuTo !== null) {
          clearTimeout(menuTo)
          menuTo = null
      }
      $(this).parent().find('.menu-dropdown').addClass('menu-dropdown--active')
  })
  $('.menu-dropdown').on('mouseenter', function () {
      $('.menu-dropdown').removeClass('menu-dropdown--active')
      if (menuTo !== null) {
          clearTimeout(menuTo)
          menuTo = null
      }
      $(this).addClass('menu-dropdown--active')
  })
  $('.header__menu__items__item').on('mouseleave', function () {
      const self = $(this)
      if (menuTo !== null) {
          clearTimeout(menuTo)
          menuTo = null
      }
      menuTo = setTimeout(function () {
          self.find('.menu-dropdown').removeClass('menu-dropdown--active')
      }, 500)

  })

  const $homeSlider = $('.-js-slider-home').owlCarousel({
      dots: false,
      nav: false,
      loop: true,
      items: 1,
      freeDrag: false,
      mouseDrag: false,
      animateOut: 'anim-out',
      animateIn: 'anim-in'
  })

  if ($('.-js-articles').length) {
      const jsowl = $('.-js-articles').owlCarousel({
          items: 1,
          nav: false,
          dots: false
      })

      jsowl.on('translated.owl.carousel', function (event) {
          $isTransitioning = false
          const parent = $(this).parent().parent()
          const year = $(this).find('.active > div > div:first-child span').text()
          $(this).parent().parent().find('.yearbook__controls span').text(year)
          $(this).parent().parent().find('.yearbook__large').text(year)
          parent.find('.yearbook__controls a').removeClass('inactive')
          $('.-js-next-slide').removeClass('slider__controls__arrow--inactive')
          $('.-js-prev-slide').removeClass('slider__controls__arrow--inactive')

          if (event.item.index == 0)
              parent.find('.yearbook__controls a:first-child').addClass('inactive')

          if (event.item.index == event.item.count - 1)
              parent.find('.yearbook__controls a:last-child').addClass('inactive')


      })

      $('.yearbook__controls ').on('click', 'a:last-child', function (e) {
          e.preventDefault()

          const owl = $(this).parent().parent().find('.-js-articles')
          owl.trigger('next.owl.carousel')
          const date = $(this).parent()
      })
      $('.yearbook__controls ').on('click', 'a:first-child', function (e) {
          e.preventDefault()

          const owl = $(this).parent().parent().find('.-js-articles')
          owl.trigger('prev.owl.carousel')
          const date = $(this).parent()
      })
  }

  $(document).on('scroll', function (e) {
      const st = $(this).scrollTop()

      if (st > 400) {
          if (!$('.header').hasClass('header--fixed')) {
              if ($('.header').hasClass('header--fp')) {
                  $('.contact-header').addClass('contact-header--fixed')
              }
              $('.header').attr('data-original-classes', $('.header').attr('class'))
              $('.header').hide()
              $('.header').fadeIn()
          }
          $('.header').addClass('header--fixed')
          $('.header').removeClass('header--white')
      } else {
          $('.contact-header').removeClass('contact-header--fixed')
          $('.header').attr('class', $('.header').attr('data-original-classes'))
          $('.contact-header').removeClass('contact-header--fixed')
      }
  })

  let $isTransitioning = false

  $('.-js-next-slide').on('click', function (e) {
      e.preventDefault()

      if ($isTransitioning) return
      $isTransitioning = true
      $homeSlider.trigger('next.owl.carousel')
      $('.owl-animated-in').addClass('slideInUp')
      $('.owl-animated-out').addClass('slideOutUp')
  })

  $homeSlider.on('translated.owl.carousel', function (event) {
      $isTransitioning = false

      $('.owl-item').removeClass('slideInUp').removeClass('slideOutUp').removeClass('slideInDown').removeClass('slideOutDown')
  })

  $('.-js-prev-slide').on('click', function (e) {
      e.preventDefault()

      if ($isTransitioning) return
      $isTransitioning = true

      $homeSlider.trigger('prev.owl.carousel')
      $('.owl-animated-in').addClass('slideInDown')
      $('.owl-animated-out').addClass('slideOutDown')
  })

  new WOW().init()

})
